<template>
  <rest-form-page
    :page-title="pageTitle"
    :fetch-endpoint="fetchEndpoint"
    :save-endpoint="saveEndpoint"
    :after-save="afterSave"
    :model="model"
    :readonly="readonly"
    :rules="rules"
  >
    <template slot="form" v-if="model">
      <form-section>
        <el-row>
          <el-col>
            <rest-form-item
              prop="title"
              :label="$t('EmailSavedRows__Title_label')"
            >
              <el-input v-model="model.title" />
            </rest-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col>
            <rest-form-item
              prop="preview"
              :label="$t('EmailSavedRows__Content_label')"
            >
              <iframe
                :srcdoc="preview"
                style="border: none"
                height="auto"
                width="100%"
              />
            </rest-form-item>
          </el-col>
        </el-row>
      </form-section>
    </template>
  </rest-form-page>
</template>

<script>
import RestFormPage from '@/common/components/rest/RestFormPage'
import { projectEndpoint, projectRoute } from '@/core/helpers'
import FormSection from '@/common/components/form/FormSection'
import RestFormItem from '@/common/components/rest/RestFormItem'

export default {
  name: 'EmailSavedRowsFormPage',

  components: {
    RestFormItem,
    FormSection,
    RestFormPage
  },

  props: {
    readonly: {
      default: false,
      type: Boolean
    },
    copy: {
      default: false,
      type: Boolean
    }
  },

  data() {
    let checkSavedRowName = (rule, value, callback) => {
      if (value.trim().length === 0) {
        return callback(
          new Error(this.$t('EmailSavedRows__Title_validation_message'))
        )
      } else {
        callback()
      }
    }

    return {
      model: null,
      rules: {
        title: [{ validator: checkSavedRowName }]
      }
    }
  },

  computed: {
    pageTitle() {
      return this.$t(this.$route.meta.title)
    },

    fetchEndpoint() {
      if (this.$route.query.id) {
        return projectEndpoint({
          method: 'get',
          url: `email-saved-rows/${this.$route.query.id}`,
          handler: data => {
            this.model = data
          }
        })
      } else {
        return null
      }
    },

    saveEndpoint() {
      if (this.$route.query.id && !this.copy) {
        return projectEndpoint({
          method: 'patch',
          url: `email-saved-rows/${this.$route.query.id}`
        })
      } else {
        return projectEndpoint({
          method: 'post',
          url: 'email-saved-rows'
        })
      }
    },

    preview() {
      return this.model.content
    }
  },

  methods: {
    afterSave() {
      this.$router.push(
        projectRoute({
          name: 'EmailRowsSaved'
        })
      )
    }
  }
}
</script>

<style scoped>
>>> input[type='email'],
>>> input[type='number'],
>>> input[type='password'],
>>> input[type='search'],
>>> input[type='text'],
>>> input[type='url'] {
  background: #fff;
  border: 1px solid #c2c4c6;
  cursor: text;
  height: 38px;
  line-height: 38px;
  outline: none;
  padding: 0 10px !important;
  color: #717782 !important;
}

>>> input:hover[type='password'],
>>> input:hover[type='text'],
>>> select:hover,
>>> textarea:hover {
  border-color: #1d87c8 !important;
}
</style>



// WEBPACK FOOTER //
// src/modules/email-saved-rows/pages/EmailSavedRowsFormPage.vue